module.exports = __webpack_public_path__ + "static/media/20s_models_temp.85360a4f.jpg";